(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/utils/assets/javascripts/setup-draw-result-toaster-config.js') >= 0) return;  svs.modules.push('/components/pool-betting/utils/assets/javascripts/setup-draw-result-toaster-config.js');
"use strict";

const {
  dialog
} = svs.components;
const setupDrawResultToasterConfig = _ref => {
  let {
    action,
    isFirst
  } = _ref;
  const toaster = new dialog.Confirm({
    area: dialog.area.TOASTER,
    branding: dialog.branding.SPORT,
    type: dialog.type.DEFAULT,
    icon: 'exclamation-sign',
    title: 'Något gick fel',
    message: [{
      type: dialog.message.TEXT,
      text: isFirst ? 'Just nu kan vi inte visa alla detaljer kring ditt spel.' : 'Just nu kan vi inte visa alla detaljer kring ditt spel. Försök igen senare'
    }],
    actions: isFirst ? [{
      title: 'Försök igen',
      callback: () => {
        action();
        toaster.close();
      }
    }, {
      title: 'Ok'
    }] : [{
      title: 'Ok'
    }]
  });
  return toaster;
};
setGlobal('svs.components.poolBetting.utils.setupDrawResultToasterConfig', setupDrawResultToasterConfig);

 })(window);